// Claves públicas para verificar la credencial de licencia (etapa 8B). Son públicas: está bien
// que estén en el código. La privada vive solo en los secretos de Supabase (LICENSE_SIGNING_KEY).
// Se generan con `npm run license-keys`. Para rotar, se agrega una nueva (con otro kid) y se
// mantiene la anterior hasta que vencen las credenciales emitidas con ella (7 días).
import type { LicensePublicKey } from './license-token.ts';

export const LICENSE_PUBLIC_KEYS: readonly LicensePublicKey[] = [
  { kid: 'k20261006-b3b2', x: 'v0v74mhmypmuDKm2CaSLJVCuqLKMrfxAJBjccDNLCqg', y: 'V4aA_zZ65Fx6_W7NisWkIp8bVr2zlB-du4-pIZW_6QI' },
];
